import { Typography } from "antd";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { useGetMessageDetails } from "../../ServerSideStates";
import { setBackEndUlr } from "helpers/SetBackEndUrl";
import endPoints from "../../EndPoints"
import { useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import AdvertInfoesSkeleton from "apps/Common/Skelton/MessageDetails/AdvertInfoesSkeleton";
import TruncatedText from "apps/Common/TruncatedText";

const AdvertInfoes = () => {
  const queryClient = useQueryClient()
  const { Text } = Typography;
  const { messageDetilsFilter } = useSelector(
    (state: RootState) => state.message
  );
  const {userInfoes} = useSelector((state:RootState)=>state.profile)
  const messageDetails = useGetMessageDetails(messageDetilsFilter);
  const messageDetailsData = messageDetails?.data?.data|| null;

  console.log("message details",messageDetailsData)

  useEffect(()=>{
    queryClient.resetQueries({
      queryKey: endPoints.getMessageGroupList,
      exact: false,
    });
  },[])


  return (
    <>
      <div className="!flex gap-4 items-center !h-full">
     <AdvertInfoesSkeleton loading={messageDetails.isLoading }>
          {
            messageDetailsData&&
            <>
            <div>
              <LazyLoadImage
                wrapperWidth="70px"
                wrapperHeight="70px"
                src={
                  setBackEndUlr() + "/" + messageDetailsData?.advertMainImage
               
                }
                alt=""
                imageClassName="!rounded-md"
              />
            </div>
            <div>
              <div>
                <Text className="!text-xs md:!text-sm !text-blue-500">
                {userInfoes?.id===messageDetailsData?.advertUserId?messageDetailsData?.contactPhoneNumber?.replace("90",""):messageDetailsData[0]?.advertPhoneNumber?.replace("90","")}
                </Text>
              </div>
              <div className="!text-xs md:!text-sm" >  
                <Text>{userInfoes?.id===messageDetailsData?.advertUserId?messageDetailsData?.contactPerson:messageDetailsData?.advertPerson}</Text>
              </div>
                <TruncatedText
                wrapperClassName=""
                textClassName="!font-bold !text-xs md:!text-sm"
                maxLines={1}
                title={messageDetailsData?.advertTitle}
                />
             
            </div>
            </>
          }
     </AdvertInfoesSkeleton>
        
    
      </div>
    </>
  );
};

export default AdvertInfoes;
